/**
 * Greenhouse Job Board chips.
 * 
 */

/**
 * Adapt Greenhouse Job Board plugin shortcode markup for theme styling.
 * Open Positions appear on HOME, JOIN.
 */

const careers = require('../components/careers-block');

function initGreenhouse() {
	// console.log('GREENHOUSE: initGreenhouse()');

	let 
		label_html = '',
		prefix = 'careers';

	// if ($('body').hasClass('join')) {
	// 	prefix = 'positions';
	// }

	label_html  = '<div class="careers-block__position-label">';
	label_html += 'Open<br>Position';
	label_html += '</div>';

	$(function() {

		$('.apply_jobs').remove();
		if ($('#job-template').length) {
			$('.all_jobs').find('.jobs').addClass('careers-block__positions');
			// $('.all_jobs').find('.job').wrapAll('<div class="careers-block__positions"></div>');
			$('.all_jobs').find('.job').each(function() {
				$(this).find( "a.job_apply" ).wrap( "<div class='careers-block__position-button'></div>" );
				// console.log($(this));

				$(this).addClass('careers-block__position');
				// Add label markup.
				$(this).prepend(label_html);
				$(this).find('.job_title').addClass('careers-block__position-title');
				// Remove Greenhouse job description markup.
				$(this).find('.job_description').remove();
				$(this).find('.job_read_full').remove();
				// Add theme button classes to link.
				$(this).find('a.job_apply').addClass('button-standard button-secondary');
				// Rewrite href URL to link to position page.
				$(this).find('a.job_apply.job_apply_' + $(this).attr('data-id')).attr('href', 'https://ats.comparably.com/api/v1/gh/remixtherapeutics/jobs/' + $(this).attr('data-id'));
				setTimeout(()=> {
					// Redefine link click function.
					$(this).find('a.job_apply_' + $(this).attr('data-id')).unbind("click").bind('click', function(e) {
						e.preventDefault();
						$(this).removeClass('open');
						var url = $(this).attr('href'); 
						window.open(url, '_blank');
					});
				}, 150);	// Between slick init and ScrollTrigger.refresh() in home.js, join.js.
			});
		} else {
			$('.all_jobs').html('<div class="container-1176"><h3 class="" style="text-align:center;">There are no current openings.</h3></div>');
		}
	});
}

exports.init = function () {
	// console.log('CAREERS: exports.init');
    // Run init methods...

	initGreenhouse();
};